/**
 * Display labels for workflow / report types used throughout the app.
 * Also drives the report-type dropdown in template uploads.
 * Values match the backend workflow type strings.
 */
export const REPORT_TYPE_LABELS: Record<string, string> = {
  renewal_analysis: 'Renewal Analysis',
  loss_run_analysis: 'Loss Run Analysis (legacy)',
  loss_run_analyzer: 'Loss Run Analyzer (legacy)',
  loss_run_analyzer_v4: 'Loss Run Analyzer (legacy NEW)',
  loss_run_analyzer_v4_3: 'Loss Run Analysis',
  document_comparison: 'Document Comparison',
  policy_comparison: 'Policy Comparison',
  research: 'Research',
  year_over_year: 'Year-over-Year Comparison',
  yoy_renewal: 'Multi-Line Renewal Review',
  personal_lines_yoy_renewal: 'Personal Lines Renewal Review',
  commercial_lines_exec_renewal: 'Executive Renewal Summary',
  client_renewal_presentation: 'Client Renewal Presentation',
  coverage_analysis: 'Coverage Analysis',
  insurance_requirements: 'Insurance Requirements',
  financial_analysis: 'Financial Analysis',
  portfolio_analyzer: 'Portfolio Analyzer',
  new_business: 'New Business',
  rate_analysis: 'Rate Analysis',
  certificate_of_effort: 'Certificate of Effort',
  homeowners_comparison: 'Homeowners Comparison',
  personal_umbrella: 'Personal Umbrella',
};

export const ALL_REPORT_TYPES = Object.keys(REPORT_TYPE_LABELS);
